import NominationRes from "types/res/nomination/NominationRes";
import {
  Box,
  MenuItem,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { Info } from "@material-ui/icons";

type RakingTableHeaderProps = {
  selectNominationId?: number;
  setSelectNominationId: any;
  nominations: NominationRes[];
  link?: boolean;
};
const CastRankingTableHeader = ({
  selectNominationId,
  setSelectNominationId,
  nominations,
  link,
}: RakingTableHeaderProps) => {
  const { t } = useTranslation("castRanking");
  return (
    <TableHead>
      <TableRow>
        <TableCell padding={"none"} width={"100px"} />
        {link && (
          <>
            <TableCell>
              <Typography style={{ fontSize: "1.2rem" }} noWrap>
                {t("columns.shopName")}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography style={{ fontSize: "1.2rem" }} noWrap>
                {t("columns.notelClassName")}
              </Typography>
            </TableCell>
          </>
        )}
        <TableCell padding={"checkbox"}>
          <Typography style={{ fontSize: "1.2rem" }} noWrap>
            {t("columns.commutingDays")}
          </Typography>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Typography style={{ fontSize: "1.2rem" }} noWrap>
            {t("columns.commutingTimes")}
          </Typography>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Typography style={{ fontSize: "1.2rem" }} noWrap>
            {t("columns.averageCommutingTimes")}
          </Typography>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Typography style={{ fontSize: "1.2rem" }} noWrap>
            {t("columns.totalOrderCount")}
          </Typography>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <TextField
            select
            value={selectNominationId || ""}
            style={{ width: "100px", fontSize: "1.2rem" }}
            inputProps={{ style: { fontSize: "1.2rem" } }}
            onChange={(event) =>
              setSelectNominationId(Number(event.target.value))
            }
          >
            {nominations.map((nomination) => (
              <MenuItem
                key={nomination.nominationId}
                value={nomination.nominationId}
              >
                <Typography style={{ fontSize: "1.2rem" }} noWrap>
                  {nomination.name}
                </Typography>
              </MenuItem>
            ))}
          </TextField>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <TextField
            select
            value={selectNominationId || ""}
            style={{ width: "100px", fontSize: "1.2rem" }}
            inputProps={{ style: { fontSize: "1.2rem" } }}
            onChange={(event) =>
              setSelectNominationId(Number(event.target.value))
            }
          >
            {nominations.map((nomination) => (
              <MenuItem
                key={nomination.nominationId}
                value={nomination.nominationId}
              >
                <Typography style={{ fontSize: "1.2rem" }} noWrap>
                  {t("columns.nominationRate", { name: nomination.name })}
                </Typography>
              </MenuItem>
            ))}
          </TextField>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Box display="flex" alignItems="center">
            <Typography style={{ fontSize: "1.2rem" }} noWrap>
              {t("columns.averageTotalOrderCount")}
            </Typography>
            <Tooltip title={t("tooltips.averageTotalOrderCount")} arrow>
              <Info />
            </Tooltip>
          </Box>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <TextField
            select
            value={selectNominationId || ""}
            style={{ width: "100px", fontSize: "1.2rem" }}
            inputProps={{ style: { fontSize: "1.2rem" } }}
            onChange={(event) =>
              setSelectNominationId(Number(event.target.value))
            }
          >
            {nominations.map((nomination) => (
              <MenuItem
                key={nomination.nominationId}
                value={nomination.nominationId}
              >
                <Typography style={{ fontSize: "1.2rem" }} noWrap>
                  {t("columns.averageNominationCount", { name: nomination.name })}
                </Typography>
              </MenuItem>
            ))}
          </TextField>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Box display="flex" alignItems="center">
            <Typography style={{ fontSize: "1.2rem" }} noWrap>
              {t("columns.repeatRate")}
            </Typography>
            <Tooltip title={t("tooltips.repeatRate")} arrow>
              <Info />
            </Tooltip>
          </Box>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Box display={"flex"} alignItems={"center"}>
            <Typography style={{ fontSize: "1.2rem" }} noWrap>
              {t("columns.breakRate")}
            </Typography>
            <Tooltip title={t("tooltips.breakRate")} arrow>
              <Info />
            </Tooltip>
          </Box>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Typography style={{ fontSize: "1.2rem" }} noWrap>
            {t("columns.sales")}
          </Typography>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Typography style={{ fontSize: "1.2rem" }} noWrap>
            {t("columns.averageSales")}
          </Typography>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Typography style={{ fontSize: "1.2rem" }} noWrap>
            {t("columns.castFee")}
          </Typography>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Box display={"flex"} alignItems={"center"}>
            <Typography style={{ fontSize: "1.2rem" }} noWrap>
              {t("columns.castFeePerHour")}
            </Typography>
            <Tooltip title={t("tooltips.castFeePerHour")} arrow>
              <Info />
            </Tooltip>
          </Box>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Typography style={{ fontSize: "1.2rem" }} noWrap>
            {t("columns.tardyCount")}
          </Typography>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Typography style={{ fontSize: "1.2rem" }} noWrap>
            {t("columns.absenceCount")}
          </Typography>
        </TableCell>
        <TableCell padding={"checkbox"}>
          <Box display={"flex"} alignItems={"center"}>
            <Typography style={{ fontSize: "1.2rem" }} noWrap>
              {t("columns.score")}
            </Typography>
            <Tooltip title={t("tooltips.score")} arrow>
              <Info />
            </Tooltip>
          </Box>
        </TableCell>
        {link && <TableCell padding={"checkbox"} />}
      </TableRow>
    </TableHead>
  );
};
export default CastRankingTableHeader;
